import cguIcon from "@assets/images/more/cgu.svg";
import feedbackIcon from "@assets/images/more/feedback.svg";
import { config } from "@core/config/config";
import { Path } from "@core/routing/path";

export const moreInfos = [
	// {
	// 	page: "faq",
	// 	pathname: "faq",
	// 	icon: require("../../../assets/images/more/faq.svg"),
	// },
	// {
	// 	page: "feedback",
	// 	pathname: "http://feedback.tooshare.com",
	// 	icon: require("../../../assets/images/more/feedback.svg"),
	// },
	{
		page: "support",
		pathname: config.supportEmail,
		icon: feedbackIcon,
	},
	{
		page: "cgu",
		pathname: Path.Cgu,
		icon: cguIcon,
	},
];
